import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as S from './styles';
import { TC_BUTTON_TYPE } from 'components/TCButton/constants';
import { TCButton } from 'components/TCButton';
import { SetShowPreview } from 'features/Dealers/Reviews/state/actions';
import { RootState } from 'store/types';
import { publishWidgetsConfig } from '../state/utils';

const ActionButtons = () => {
    const dispatch = useDispatch();
    const { selectedTab } = useSelector((rootState: RootState) => {
        return {
            selectedTab: rootState.reviews.selectedTab,
        }
    }, shallowEqual);
    const [publishing, setPublishing] = React.useState(false);
    const [sameConfig, setSameConfig] = React.useState(true);
    const {
        widgets,
        widgetsPublish,
        reviewsConfig,
        showPreview
    } = useSelector((rootState: RootState) => {
        return {
            widgets: rootState.reviews.widgets,
            widgetsPublish: rootState.reviews.widgetsPublish,
            reviewsConfig: rootState.reviews.reviewsConfig,
            showPreview: rootState.reviews.showPreview,
        }
    }, shallowEqual);

    React.useEffect(() => {
        if (widgets || widgetsPublish) {
            if (selectedTab.toLocaleLowerCase() == "entire") {
                const equalObjects = (JSON.stringify(widgets?.entireConfig) === JSON.stringify(widgetsPublish?.entireConfig));
                setSameConfig(equalObjects);
                }
            else {
                const equalObjects = (JSON.stringify(widgets?.individualConfig) === JSON.stringify(widgetsPublish?.individualConfig));
                setSameConfig(equalObjects);
            }
        }
    }, [widgets, widgetsPublish, selectedTab]);    
    
    const handlePreview = () => {
        dispatch(SetShowPreview(!showPreview))
    }

    const handlePublish = async () => {
        if (widgets) {
            setPublishing(true);
            try {
                await publishWidgetsConfig(dispatch, widgets, selectedTab);
            } catch(e) {
                console.error(e);
            }
            setPublishing(false);
        }
    }

    return (
        <S.MainContainer>
            <S.ButtonContainer>
            {
                reviewsConfig?.showPreviewButton &&
                <TCButton
                    type={TC_BUTTON_TYPE.SECONDARY}
                    onClick={() => handlePreview()}
                    backgroudColor={undefined}
                >
                    {
                        showPreview ? 'Back to Edit' : 'Preview'
                    }
                </TCButton>
            }
            </S.ButtonContainer>
            <S.ButtonContainer>
            <TCButton 
                loading={false}
                loaderColor='#66ADFF'
                loaderButtonBackgroudColor='#FFF'
                loaderButtonWidth={150}
                type={TC_BUTTON_TYPE.SECONDARY}
                onClick={handlePublish}
                disabled={sameConfig || publishing}
            >
                { publishing ? 'Publishing...' : (selectedTab === "entire"?'Publish Page':'Publish Changes')}
            </TCButton>
            </S.ButtonContainer>
        </S.MainContainer>
    )
}

export default ActionButtons;
